import { FilterItem } from "../filters";

export enum PerformerTypeEnum {
  MANAGER = "managerUser",
  CLIENT = "clientUser",
  ADMIN = "adminUser",
}

export const MANAGEMENT_PERFORMER_TYPE_OPTIONS: FilterItem[] = [
  { value: String(PerformerTypeEnum.MANAGER), label: "Gestor" },
  { value: String(PerformerTypeEnum.CLIENT), label: "Cliente" },
  { value: String(PerformerTypeEnum.ADMIN), label: "Administrador" },
];
